import { gql } from '@apollo/client';
export const RULE_FIELDS = gql `
  fragment RuleFields on Rule {
    id
    createdAt
    updatedAt
    clientId
    ruleType
    policy
    criteria
    sortOrder
    isActive
    startsOn
    expiresOn
    target
    isException
    comment
  }
`;
export const RULES = gql `
  ${RULE_FIELDS}
  query RULES($spec: RuleSpec!) {
    rules(spec: $spec) {
      ...RuleFields
    }
  }
`;
export const SAVE_RULE = gql `
  ${RULE_FIELDS}
  mutation SAVE_RULE($input: RuleInput!) {
    saveRule(input: $input) {
      ...RuleFields
    }
  }
`;
export const DELETE_RULE = gql `
  ${RULE_FIELDS}
  mutation DELETE_RULE($id: Int!) {
    deleteRule(id: $id) {
      ...RuleFields
    }
  }
`;
export const REORDER_RULES = gql `
  ${RULE_FIELDS}
  mutation REORDER_RULES($ids: [Int!]!) {
    reorderRules(ids: $ids) {
      ...RuleFields
    }
  }
`;
